import React from "react";
import { Modal, Input } from "antd";

function CreateFolderModal({
    open,
    folderName,
    onFolderNameChange,
    onCancel,
    onOk,
    confirmLoading,
}) {
    return (
        <Modal
            open={open}
            title="New Folder"
            onCancel={onCancel}
            onOk={onOk}
            confirmLoading={confirmLoading}
        >
            <Input
                placeholder="Folder name"
                value={folderName}
                onChange={(e) => onFolderNameChange(e.target.value)}
                autoFocus
            />
        </Modal>
    );
}

export default CreateFolderModal;
